import React from 'react';

import Value from './value';

function UrlValue({  ...props }) {
  return <Value {...props} isUrl />;
}

UrlValue.propTypes = Value.propTypes;

export default UrlValue;
